import { useEffect } from 'react'

import { provideComponent } from 'scrivito'

import { DXPDetailsWidget } from './DXPDetailsWidgetClass'
import { LeftColumn } from './LeftColumn'
import { setCurrentPageContext } from '@/Atomic/Widgets/AiChatBot/core/engine/pipeline/page-context'
import { DataItemDetails } from '@/Atomic/Widgets/DataItemDetails'
import { DataItemHeader } from '@/Atomic/Widgets/DataItemHeader'
import { DataItemNavTabs } from '@/Atomic/Widgets/DataItemTabs'
import { SegmentFilter } from '@/Atomic/Widgets/SegmentFilter'
import { Loading } from '@/Components/Loading'
import { DataClassName } from '@/Data/const'
import { FormGroupProvider } from '@/hooks/useFormGroupHandler'
import { useStableDataItem } from '@/hooks/useStableDataItem'

import './DXPDetailsWidget.scss'

provideComponent(
  DXPDetailsWidget,
  () => {
    const dataItem = useStableDataItem()
    const dataClassName = dataItem?.dataClassName() || ''
    const dataItemId = dataItem?.id()

    useEffect(() => {
      if (typeof document === 'undefined') return

      const main = document.querySelector('main')
      if (main) {
        main.scrollTop = 0
      }
    }, [dataItemId])

    useEffect(() => {
      if (dataClassName && dataItemId) {
        setCurrentPageContext({ dataClassName, entityId: dataItemId })
      } else {
        setCurrentPageContext(null)
      }
      return () => setCurrentPageContext(null)
    }, [dataClassName, dataItemId])

    if (!dataItem?.id()) return

    const content = (
      <FormGroupProvider>
        {/* page card header */}
        <DataItemHeader dataItem={dataItem} />

        <div className="row">
          {/* left column */}
          <div className="col-sm-12 col-md-12 col-lg-5 dxp-details-left-column">
            <DataItemDetails dataItem={dataItem} />
            <LeftColumn dataClassName={dataClassName} dataItem={dataItem} />
          </div>

          {/* right column */}
          <div className="col-sm-12 col-md-12 col-lg-7 dxp-details-right-column--tabs">
            <DataItemNavTabs />
          </div>
        </div>
      </FormGroupProvider>
    )

    return dataClassName === DataClassName.LIST ? (
      <SegmentFilter listId={dataItem.id()}>{content}</SegmentFilter>
    ) : (
      content
    )
  },
  { loading: Loading },
)
